import { Link } from "react-router-dom";

// Two-panel auth shell: brand/marketing on the left, form on the right.
export default function AuthLayout({ eyebrow, title, subtitle, children, aside }) {
  return (
    <section className="auth">
      <div className="auth__brandpane">
        <div className="auth__brandpane-scrim" />
        <div className="auth__brandpane-inner">
          <Link to="/" className="auth__logo">
            Rimm<span className="hdr__logo-o">o</span>n<strong>Farm</strong>
          </Link>
          <div className="auth__brandpane-copy">
            <h2>{aside?.heading || "Farm-fresh, direct to your door"}</h2>
            <ul className="auth__perks">
              {(aside?.perks || [
                "Free-range & pasteurized eggs",
                "Daily milk & live poultry",
                "Seasonal Andhra mangoes",
                "Order on WhatsApp in seconds",
              ]).map((p) => (
                <li key={p}>✓ {p}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="auth__formpane">
        <div className="auth__form-wrap">
          {eyebrow && <span className="section__tag">{eyebrow}</span>}
          <h1 className="auth__title">{title}</h1>
          {subtitle && <p className="auth__subtitle">{subtitle}</p>}
          {children}
        </div>
      </div>
    </section>
  );
}
